<div role="dialog" aria-labelledby="dialogTitle" >
  <div class="modal-header">
    <h2 id="dialogTitle" class="modal-title module-title">{{"multistep.workflow.title" | translate}}</h2>
    <button  type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <span class="icon-Close" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="displayPlanName">
      <div class="col-12">
        <label class="text-uppercase input-label">{{"multistep.workflow.label.plan.name" | translate}}</label>
        <p>
          {{planName}}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="text-uppercase input-label">{{"multistep.workflow.label.workflow.name" | translate}}</label>
        <p>
          {{this.mswfData.workflowName}}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="text-uppercase input-label">{{"multistep.workflow.label.ct.set" | translate}}</label>
        <p>
          {{ctSetName}}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="input-label no-text-decoration">{{"multistep.workflow.label.workflow.cts" | translate}}</label>
          <ag-grid-angular
            class="ag-theme-balham no-column-borders"
            [rowHeight]="45"
            [headerHeight]="45"
            [defaultColDef]="defaultColDef"
            [columnDefs]="colDefs"
            [rowData]="rules"
            [components]="frameworkComponents"
            [suppressLoadingOverlay]="true"
            enableBrowserTooltips="true"
            (gridReady)="onGridReady($event)"
            [animateRows]="false">

          </ag-grid-angular>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'btn.close'|translate}}"
                     id="accept-btn"
                     [isPrimary]="true"
                     (clicked)="dismiss()"></breeze-button>
    </div>
  </div>
</div>
